import React from 'react';
import PropTypes from 'prop-types';

import ImageLoader from '../../../react/components/ImageLoader';
import Button from '../../../react/components/Button';
import Modal from './Modal';
import { wysiwygBlockTypes } from '../propTypes';

const ConcertCard = ({
  blocks,
  image,
  performancesViewTeaser,
  productionSeasonId,
  setModal,
  synopsis,
  title,
}: ConcertCardProps) => {
  const generateButtonHtml = (linkObject, key) => (
    <a
      className="c-button c-button--small u-spacing-bottom-base u-spacing-right-base"
      href={linkObject.link}
      key={`${title}${key}`}
      rel="noreferrer"
      tabIndex={0}
      target={linkObject.link.target ? '_blank' : '_self'}
    >
      <span>
        {linkObject.text}
      </span>
    </a>
  );

  const generateContentFromBlocks = () => (
    <div>
      {blocks.map((block) => {
        if (!block) return false;

        return (
          <>
            {block.content && (
              <div
                dangerouslySetInnerHTML={{ __html: block.content }}
                key={`${title}content`}
              />
            )}
            {(!(block.ctaText.length === 0) || !(block.secondaryCtaButton.length === 0)) && (
              <div className="u-spacing-top-medium">
                {!(block.ctaText.length === 0) && generateButtonHtml(block.ctaText, 'ctaText')}
                {!(block.secondaryCtaButton.length === 0) && generateButtonHtml(block.secondaryCtaButton, 'secondaryCtaButton')}
              </div>
            )}
          </>
        );
      })}
    </div>
  );

  const handleShowDescription = () => {
    document.body.classList.add('has-modal-opened');

    const description = generateContentFromBlocks();

    setModal(
      <Modal
        heading={title}
        setModal={setModal}
        text={description}
        type="concert-details"
      />,
    );
  };

  const handleAddToPackClick = () => {
    document.body.classList.add('has-modal-opened');

    setModal(
      <Modal
        heading={title}
        productionSeasonId={productionSeasonId}
        setModal={setModal}
        text={<div>{synopsis}</div>}
        type="select-performance"
      />,
    );
  };

  return (
    <div className="js-card">
      <div className="c-card-listing__inner">
        <div className="c-card  c-card--regular">
          <div className="c-card__link  g-split-image">
            <div
              className="c-card__inner c-card__inner--clickable"
              onClick={handleShowDescription}
              onKeyDown={handleShowDescription}
              tabIndex={0}
              role="button"
            >
              <ImageLoader image={image} alt={title} />
            </div>

            <div className="c-card__content">
              {title && (
                <div
                  onClick={handleShowDescription}
                  onKeyDown={handleShowDescription}
                  tabIndex={0}
                  role="button"
                >
                  <h4 className="c-card__title">
                    {title}
                  </h4>
                </div>
              )}
              {synopsis && <p className="c-card__synopsis">{synopsis}</p>}
              {performancesViewTeaser && <p className="c-card__meta">{performancesViewTeaser}</p>}

              <Button
                addToPack
                onClick={handleAddToPackClick}
                onKeyDown={handleAddToPackClick}
                role="button"
                tabIndex={0}
              >
                Add To Pack
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const concertCardPropTypes = {
  blocks: PropTypes.arrayOf(wysiwygBlockTypes).isRequired,
  image: PropTypes.string.isRequired,
  performancesViewTeaser: PropTypes.string.isRequired,
  productionSeasonId: PropTypes.number.isRequired,
  setModal: PropTypes.func.isRequired,
  synopsis: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

ConcertCard.propTypes = concertCardPropTypes;

type ConcertCardProps = PropTypes.InferProps<typeof concertCardPropTypes>;

export default ConcertCard;
